import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {EventListComponent} from './event/event-list/event-list.component';
import {PlaySpaceFormComponent} from './playspace/play-space.component';
import {FeedbackComponent} from './feedback/feedback.component';
import {HelpComponent} from './help/help.component';
import {PlayerDetailFormComponent} from './player/player-detail/player-detail.component';
import {ChatComponent} from './chat/chat.component';
import {EventDetailComponent} from './event/event-detail/event-detail.component';
import {EventPlayersComponent} from "./event/event-players/event-players.component";
import {EventPlayerManagementComponent} from "./event/event-player-management/event-player-management.component";
import {ChatListComponent} from "./chat/chat-list/chat-list.component";
import {ChatDetailComponent} from "./chat/chat-detail/chat-detail.component";
import {ChatSettingsComponent} from "./chat/chat-settings/chat-settings.component";
import {ChatAddMembersComponent} from "./chat/chat-add-members/chat-add-members.component";
import {GuestClaimComponent} from "./player/guest-claim/guest-claim.component";
import {PublicPlayerProfileComponent} from "./player/public-player-profile/public-player-profile.component";
import {PlayerMatchHistoryComponent} from "./player/player-match-history/player-match-history.component";
import {PlayerFootballerFriendsComponent} from "./player/player-footballer-friends/player-footballer-friends.component";
import {PlayerFootballReferencesComponent} from "./player/player-football-references/player-football-references.component";
import {GuestOwnerComponent} from "./event/guest-owner/guest-owner.component";
import {PublicEventInviteComponent} from "./event/public-event-invite/public-event-invite.component";
import {NotificationsComponent} from "./event/notifications/notifications.component";
import {RatingReviewComponent} from "./event/rating-review/rating-review.component";
import {GuestUpgradeComponent} from "./event/guest-upgrade/guest-upgrade.component";
import {EmailVerificationResultComponent} from "./email-verification-result/email-verification-result.component";

import { matchScreenResolver, matchHomeResolver } from "./event/match-home/match-screen.resolver";

import { supportScreenResolver } from './shared/services/support-screen.resolver';
import { FootballerAuthComponent } from './auth/footballer-auth.component';

const routes: Routes = [
  {path: 'auth', component: FootballerAuthComponent},
  {path: '', component: EventListComponent, resolve: { home: matchHomeResolver }},

  {path: 'event-list', component: EventListComponent, resolve: { home: matchHomeResolver }},
  {path: 'event-detail/:editSelectedEvent', component: EventDetailComponent, resolve: { match: matchScreenResolver }, runGuardsAndResolvers: 'paramsOrQueryParamsChange'},
  {path: 'event-players/:editSelectedEvent', component: EventPlayersComponent, resolve: { match: matchScreenResolver }, runGuardsAndResolvers: 'paramsOrQueryParamsChange'},
  {path: 'event-player-management/:eventId', component: EventPlayerManagementComponent},
  {path: 'notifications', component: NotificationsComponent, resolve: { screen: supportScreenResolver }},
  {path: 'rating-review/:reviewId', component: RatingReviewComponent},

  {path: 'messages', component: ChatComponent, resolve: { screen: supportScreenResolver }},
  {path: 'chat-list', component: ChatListComponent, resolve: { screen: supportScreenResolver }},
  {path: 'chat-detail', component: ChatDetailComponent},
  {path: 'chat-settings', component: ChatSettingsComponent, resolve: { screen: supportScreenResolver }},
  {path: 'chat-add-members', component: ChatAddMembersComponent},

  {path: 'help', component: HelpComponent},
  {path: 'player-detail/:eventDetailMode', component: PlayerDetailFormComponent, resolve: { screen: supportScreenResolver }},
  {path: 'player/footballer-friends', component: PlayerFootballerFriendsComponent, resolve: { screen: supportScreenResolver }},
  {path: 'player/:playerId/football-references', component: PlayerFootballReferencesComponent, resolve: { screen: supportScreenResolver }},
  {path: 'player/:playerId/match-history', component: PlayerMatchHistoryComponent, resolve: { screen: supportScreenResolver }},
  {path: 'profile/:playerId', component: PublicPlayerProfileComponent, resolve: { screen: supportScreenResolver }, runGuardsAndResolvers: 'always'},
  {path: 'claim/:token', component: GuestClaimComponent},
  {path: 'guest-manager', component: GuestOwnerComponent},
  {path: 'guest-upgrade', component: GuestUpgradeComponent},
  {path: 'email-verified', component: EmailVerificationResultComponent},
  {path: 'join/:inviteToken', component: PublicEventInviteComponent},
  {path: 'public-event-invite/:inviteToken', component: PublicEventInviteComponent},
  {path: 'i/:inviteToken', component: PublicEventInviteComponent},
  {path: 'feedback', component: FeedbackComponent},
  {path: 'playspace/:createNewPlayspace', component: PlaySpaceFormComponent, resolve: { screen: supportScreenResolver }},

  {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top'
} /*, { enableTracing: true } */ /*, { enableTracing: true } */ /*, { enableTracing: true } *//*, { enableTracing: true } */)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
